import { Injectable } from '@angular/core';
import { DetectedLocation, LatLong } from './address-autofill.service';

export interface AddressAutofillHandoff {
  location: DetectedLocation;
  coordinates: LatLong | null;
  reverseGeocodeResponse: unknown;
  buildingDetails: string;
  landmark: string;
  localityDetails: string;
}

@Injectable({ providedIn: 'root' })
export class AddressAutofillHandoffService {
  private handoff: AddressAutofillHandoff | null = null;

  set(handoff: AddressAutofillHandoff): void {
    this.handoff = handoff;
  }

  consume(): AddressAutofillHandoff | null {
    const handoff = this.handoff;
    this.handoff = null;
    return handoff;
  }
}
